import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/HomeView.vue') },
  { path: '/products', name: 'Products', component: () => import('../views/ProductsView.vue') },
  { path: '/products/:id', name: 'ProductDetail', component: () => import('../views/ProductDetailView.vue') },
  { path: '/about', name: 'About', component: () => import('../views/AboutView.vue') },
  { path: '/bases', name: 'Bases', component: () => import('../views/BasesView.vue') },
  { path: '/quality', name: 'Quality', component: () => import('../views/QualityView.vue') },
  { path: '/global', name: 'GlobalVision', component: () => import('../views/ShenzhenView.vue') },
  { path: '/news', name: 'News', component: () => import('../views/NewsView.vue') },
  { path: '/contact', name: 'Contact', component: () => import('../views/ContactView.vue') },
  { path: '/quote', name: 'Quote', component: () => import('../views/QuoteView.vue') }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Restore prior scroll on browser back/forward.
    if (savedPosition) return savedPosition
    // Same path, only the query changed (search deep-links, in-page filters):
    // keep the current scroll position instead of jumping to the top.
    if (to.path === from.path && JSON.stringify(to.query) !== JSON.stringify(from.query)) {
      return false
    }
    return { top: 0 }
  }
})

export default router
